"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isLocal;

/**
 * @param {string} path
 * @returns {boolean}
 */
function isLocal(path) {
  return /^(https?:)?\/\/localhost($|[/:])/.test(path);
}
//# sourceMappingURL=isLocal.js.map